/**
 * Re-export shim — the auth-retry marker moved to `@heidi/auth/contracts`
 * (OpenSpec `monorepo-auth-package` · S1). Name-intact for `scribeAPI.ts`,
 * `scribeHttpErrorHandler.ts`, and `chunkAudioRecorder.ts`.
 */
export { wasRetriedByAuthHandler } from '@heidi/auth/contracts';
export type { AuthRetriedConfig } from '@heidi/auth/contracts';
